export function LoadingScreen() {
  return (
    <div
      className="flex min-h-screen items-center justify-center text-sm"
      style={{
        backgroundColor: "var(--cn-horror-bg)",
        color: "var(--cn-horror-text-muted)",
      }}
    >
      게임 상태를 불러오는 중...
    </div>
  );
}
